// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","tuvBadges":"TuvBadges_tuvBadges__zaaB7","badge":"TuvBadges_badge__jewWI"};